export interface VideoSubtitleType {
  id?: number;
  video: number;
  lang: 'en' | 'ko' | 'jp' | 'es' | 'zh';
  file?: File | string;
  subtitle_url?: string;
  external_url?: string;
  is_integrated: boolean;
  created?: string;
  updated?: string;
  file_url?: string; // subtitle file url
}

export const LANGUAGE_OPTIONS = [
  { value: 'ko', label: 'Korea', flag: '🇰🇷' },
  { value: 'en', label: 'English', flag: '🇺🇸' },
  { value: 'jp', label: 'Japanese', flag: '🇯🇵' },
  { value: 'es', label: 'Spanish', flag: '🇪🇸' },
  { value: 'zh', label: 'Chinese', flag: '🇨🇳' },
] as const;
